import { Skeleton } from '@/core/tamagoshi/Skeleton/Skeleton';

import styles from './outlineBundleCheckbox.module.scss';

const OutlineBundleCheckboxSkel = () => (
  <div className={styles.checkboxWrapper}>
    <Skeleton className={styles.checkbox} />
    <Skeleton className={styles.checkboxLabel} height="14px" width="100px" />
  </div>
);

OutlineBundleCheckboxSkel.displayName = 'OutlineBundleCheckboxSkel';

export default OutlineBundleCheckboxSkel;
